import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-billing-address"
export default class extends Controller {
  connect() {
    const billingAddressCheckbox = document.querySelector('#billing-information-same-as-account');
    billingAddressCheckbox.addEventListener('click', function() {
      const blankBillingFields = document.querySelector('#unpopulated-billing-information');
      const populatedBillingFields = document.querySelector('#populated-billing-information');
      if (billingAddressCheckbox.checked) {
        blankBillingFields.setAttribute('style', 'display: none;');
        populatedBillingFields.setAttribute('style', '');
      } else {
        blankBillingFields.setAttribute('style', '');
        populatedBillingFields.setAttribute('style', 'display: none;');
      }
    });

  }
}
